import * as React from 'react';
import { connect } from 'react-redux';
import { Route, RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';
import { AppsManagementContent } from '../Components/Dashboard/AppsManagementContent';
import { Layout } from '../Components/Layout';
import { IApplicationState, IConnectedReduxProps } from '../Store';
import {
	hideDrawer,
	setDrawerContent,
	setPageContent,
	showDrawer,
} from '../Store/Layout/Actions';
import { IUserState } from '../Store/User/Types';

export interface IRouterMatchParams {
	groupName: string;
	type: string;
}

interface IPropsFromState {
	user: IUserState;
	router: RouteComponentProps<IRouterMatchParams>;
}

interface IPropsFromDispatch {
	setDrawerContent: typeof setDrawerContent;
	setPageContent: typeof setPageContent;
	showDrawer: typeof showDrawer;
	hideDrawer: typeof hideDrawer;
}

type AllProps = IPropsFromDispatch &
	IPropsFromState &
	RouteComponentProps<{}> &
	IConnectedReduxProps;

export class AppsManagementPage extends React.Component<AllProps> {
	componentDidMount() {
		this.props.showDrawer();

		switch (this.props.router.match.params.type) {
			case 'mediaarchiver':
				this.props.showDrawer();
				this.props.setPageContent(
					<Route component={AppsManagementContent} />
				);
				break;
			case 'channels':
				this.props.showDrawer();
				this.props.setPageContent(
					<Route component={AppsManagementContent} />
				);
				break;
			default:
				this.props.hideDrawer();
				this.props.setPageContent(
					<Route component={AppsManagementContent} />
				);
				break;
		}
	}

	componentDidUpdate() {
		switch (this.props.router.match.params.type) {
			case 'mediaarchiver':
				this.props.hideDrawer();
				this.props.setPageContent(
					<Route component={AppsManagementContent} />
				);
				break;
			case 'mediaarchiver-user':
				this.props.hideDrawer();
				this.props.setPageContent(
					<Route component={AppsManagementContent} />
				);
				break;
			case 'mediaarchiver-group':
				this.props.hideDrawer();
				this.props.setPageContent(
					<Route component={AppsManagementContent} />
				);
				break;
			default:
				this.props.hideDrawer();
				this.props.setPageContent(
					<Route component={AppsManagementContent} />
				);
				break;
		}
	}
	public render(): React.ReactNode {
		return <Route component={Layout} />;
	}
}

const mapStateToProps = (
	state: IApplicationState,
	ownProps: RouteComponentProps<IRouterMatchParams>
) => ({
	router: ownProps,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	setDrawerContent: (c: React.ReactNode) => dispatch(setDrawerContent(c)),
	setPageContent: (c: React.ReactNode) => dispatch(setPageContent(c)),
	showDrawer: () => dispatch(showDrawer()),
	hideDrawer: () => dispatch(hideDrawer()),
});

export const AppsManagement = connect(
	mapStateToProps,
	mapDispatchToProps
)(AppsManagementPage);
